export default __webpack_public_path__ + "static/media/entity-comparison.png";